__turbopack_context__.v({
  "root": "DesktopSleepComponent-module__NohOjG__root",
});
